import { render } from "./IconTrekMotor.vue?vue&type=template&id=4008ab5b"
import script from "./IconTrekMotor.vue?vue&type=script&lang=js"
export * from "./IconTrekMotor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__